package com.merkost.handpass.api.dto

import kotlinx.serialization.Serializable

@Serializable
data class FieldError(
    val field: String,
    val code: String,
    val message: String,
    val constraints: Map<String, String>? = null
)
